// extracted by mini-css-extract-plugin
module.exports = {"scrollbars":"lcphwleV2UUmO0vVYd760","imageProps":"_1WmIyBjRdmxe7NJj9nyse5"};